import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as NotificationAction from './actions';
import { NotificationService } from "./service";

@Injectable()
export class NotificationEffect {

    constructor(
        private action: Actions,
        private notificationService: NotificationService
    ) { }

    GetNotificationList = createEffect(() => this.action.pipe(
        ofType(type.GET_NOTIFICATION_LIST),
        switchMap((data) => this.notificationService.getNotificationList()),
        map((data: Array<any>) => new NotificationAction.NotificationList(data)
        )
    ));

    GetNotificationTemplateList = createEffect(() => this.action.pipe(
        ofType(type.GET_NOTIFICATION_TEMPLATE_LIST),
        switchMap((data) => this.notificationService.getNotificationTemplateList()),
        map((data: Array<any>) => new NotificationAction.NotificationTemplateList(data)
        )
    ));

    NotificationById = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_NOTIFICATION_BY_ID),
        switchMap((data: any) => this.notificationService.getNotificationById(data.payload)),
        map((data: Array<any>) => new NotificationAction.NotificationById(data)
        )
    ));

    AddNotification = createEffect(() => this.action.pipe(
        ofType(type.ADD_NOTIFICATION),
        switchMap((data: any) => this.notificationService.addNotification(data.payload)),
        map((data: any) => new NotificationAction.AddNotificationResponse(data)
        )
    ));

    UpdateNotification = createEffect(() => this.action.pipe(
        ofType(type.UPDATE_NOTIFICATION),
        switchMap((data: any) => this.notificationService.updateNotification(data.payload)),
        map((data: any) => new NotificationAction.UpdateNotificationResponse(data)
        )
    ));

    DeleteNotification = createEffect(() => this.action.pipe(
        ofType(type.DELETE_NOTIFICATION),
        switchMap((data: any) => this.notificationService.deleteNotification(data.payload)),
        map((data: any) => new NotificationAction.DeleteNotificationResponse(data)
        )
    ));

    SearchNotificationByFields = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_NOTIFICATION_BY_FIELD),
        switchMap((data: any) => this.notificationService.searchNotificationByFields(data.payload)),
        map((data) => new NotificationAction.NotificationByFieldList(data)
        )
    ));
}
